<template>
  <div>
    <div class="con" v-if="pcis">
      <div class="main">
        <div class="main-logo">
          <span class="iconfont icon-ziyuan20"></span>
          <p>让大批量普工招聘变简单</p>
        </div>
        <div class="contact">
          <div class="divider"></div>
          <div class="content">
            <p class="contact-top">CONTACT US</p>
            <p class="phone"><span class="th el-icon-phone"> </span><span class="td">(0755) 8320 7865</span></p>
            <p class="address"><span class="th el-icon-location"> </span><span class="td">深圳市福田区天地源 • 盛唐商务大厦601</span></p>
            <p class="record"><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">Copyright 2019深圳汇客科技有限公司备案号：粤ICP备19008781号-1</a></p>
          </div>
          <div class="divider"></div>
        </div>
        <div class="main-qrCode">
          <div style="text-align:center;padding-top: 10px;">
            <img src="@/assets/qrCode.jpg" alt="">
            <p>关注公众号</p>
          </div>
        </div>
      </div>
    </div>
    <div class="move-con" v-else>
      <div class="main-logo">
        <span class="logo iconfont icon-ziyuan20"></span>
        <span class="logo-text"><span></span>让大批量普工招聘变简单</span>
      </div>
      <div class="move-content">
        <div class="qrcord">
          <div style="text-align:center;">
            <img src="@/assets/qrCode.jpg" alt="">
            <p>关注公众号</p>
          </div>
        </div>
        <div class="move-text">
          <p class="contact-top">CONTACT US</p>
          <p class="phone"><span class="th el-icon-phone"> </span><span class="td">(0755) 8320 7865</span></p>
          <p class="address"><span class="th el-icon-location"> </span><span class="td">深圳市福田区天地源 • 盛唐商务大厦601</span></p>
          <p class="record"><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">Copyright 2019深圳汇客科技有限公司备案号：粤ICP备19008781号-1</a></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      pcis: this.$store.state.pcIs, // 根据窗口大小变化来判断移动端PC端
    }
  }
}
</script>

<style lang='less' scoped>
.con {
  width: 100%;
  height: 287px;
  background: #414141;
  .main{
    width: 1200px;
    height: 100%;
    padding: 0 15px;
    margin: auto;
    display: flex;
    >div {
      height: 100%;
      .icon-ziyuan20 {
        color: #8e8e8e;
        font-size: 71px;
      }
    }
    .main-logo {
      width: 305px;
      display:flex;
      flex-direction: column;
      justify-content: center;
      >p {
        font-size: 16px;
        font-weight: 400;
        color: #8E8E8E;
        letter-spacing: 3px;
      }
    }
    .main-qrCode {
      width: 357px;
      font-size: 20px;
      font-weight: 500;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      color: #8e8e8e;
      img {
        width: 141px;
        height: 141px;
        margin-bottom: 7px;
      }
    }
    .contact {
      width: 627px;
      font-size: 16px;
      font-weight: 500;
      color: #999;
      line-height: 33px;
      display:flex;
      justify-content: space-between;
      align-items: center;
      .content {
        margin-top: 56px;
      }
      .contact-top {
        font-size: 52px;
        font-weight: 800;
        color: #8E8E8E;
        line-height: 78px;
        text-align: center;
      }
      p {
        line-height: 24px;
        margin: 0;
      }
      .address, .phone {
        padding: 0 64px;
      }
      .th {
        color: #999999;
      }
      .td {
        margin-left: 5px;
        color: #FFFFFF;
      }
      .record {
        color: #8e8e8e;
        font-size: 14px;
        font-weight: 400;
        margin-top: 30px;
        a {
          color: #8e8e8e;
        }
      }
      .divider {
        width: 1px;
        height: 131px;
        background: #4E4E4E;
      }
    }
  }
}
</style>
<style lang="less" scoped>
p {
  padding: 0;
  margin: 0;
}
// 移动端
.move-con {
  width: 100%;
  height: 706px;
  background: #414141;
  padding: 0 32px;
  .main-logo {
    padding-top: 40px;
    padding-bottom: 10px;
    border-bottom: 1px solid #4E4E4EFF;
    color: #8E8E8E;
    .icon-ziyuan20 {
      font-size: 129px;
    }
    .logo-text {
      font-size: 54px;
      font-weight: bold;
      vertical-align: super;
      >span {
        margin: 0 32px 0 40px;
        border-left: 6.4px solid #8E8E8E; 
      }
    }
  }
  .move-content {
    display: flex;
    padding-top: 74px;
    .qrcord {
      margin-right: 132px;
      img {
        width: 230px;
        height: 230px;
      }
      p {
        margin-top: 13px;
        font-size: 31px;
        font-weight: 500;
        color: #8E8E8E;
        line-height: 46px;
      }
    }
    .move-text {
      .contact-top {
        font-size: 83px;
        font-weight: 800;
        color: #8E8E8E;
        line-height: 83px;
        margin-bottom: 34px;
      }
      .phone, .address {
        font-size: 26px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 38px;
        margin-bottom: 14px;
        .td {
          margin-left: 18px;
        }
      }
      .record {
        margin-top:40px;
        font-size: 22px;
        font-weight: 400;
        color: #C8C8C8;
        line-height: 44.8px;
        a {
          color: #8e8e8e;
        }
      }
    }
  }
}
</style>


